import React, { useEffect, useState } from "react";
import { Dumbbell } from "lucide-react";
import { api } from "../../lib/api";
import { Block, Note } from "./ui";

const GROUPS = [
  { key: "checkpoint", title: "Checkpoint routines", hint: "tagged with their checkpoints (BS-)" },
  { key: "constraint", title: "Constraint work", hint: "tagged with the selected constraints (SHC-)" },
  { key: "phase", title: "Phase work", hint: "tagged with the breakdown phase, footwork or movement" },
];

// Layer 4 · Routines, filled from shooting_drills by ID. `eid` is set only for saved assessments.
export function Layer4Routines({ L, ev, playerId, eid }) {
  const [drills, setDrills] = useState(null);
  useEffect(() => { if (eid) api.shootingEvaluationDrills(playerId, eid).then(setDrills).catch(() => setDrills({})); }, [playerId, eid]);
  const l3 = ev.layer3 || {};
  const tagsFor = { checkpoint: l3.checkpoint_ids || [], constraint: l3.selected_constraint_ids || [], phase: [ev.breakdown_phase_id || ev.layer2?.breakdown_phase_id].filter(Boolean) };
  return (
    <Block kicker="Layer 4 · Routines" title="What do they do every day?" subtitle="Routines help the player build consistent habits with their checkpoints" testid="se-layer4">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
        {GROUPS.map(g => { const rows = drills?.[g.key] || []; return (
          <div key={g.key} className="border border-white/10 bg-[#101010] p-4" data-testid={`se-routines-${g.key}`}>
            <div className="font-heading uppercase text-white text-base">{g.title}</div>
            <div className="text-[9px] uppercase tracking-[0.3em] text-[#757575] mb-2">{g.hint}</div>
            <div className="flex flex-wrap gap-1 mb-3">{tagsFor[g.key].map(id => <span key={id} className="text-[9px] uppercase tracking-[0.2em] px-1.5 py-0.5 border border-white/10 text-[#a0a0a0]">{L.nameOf(id)}</span>)}{!tagsFor[g.key].length && <span className="text-[10px] text-[#575757]">no tags yet</span>}</div>
            {rows.length === 0 ? (
              <div className="flex items-center gap-2 text-[#757575] text-xs" data-testid={`se-routines-${g.key}-empty`}><Dumbbell className="w-4 h-4" /> Routines coming soon</div>
            ) : rows.map(d => <div key={d.drill_id} className="border border-white/10 p-2 mb-1.5"><div className="text-sm font-bold text-white">{d.name}</div><div className="text-xs text-[#a0a0a0]">{d.description}</div>{d.reps_or_time && <div className="text-[10px] text-[#757575] mt-0.5">{d.reps_or_time}</div>}</div>)}
          </div>); })}
      </div>
      <Note testid="se-retest">Then retest Layers 1 and 2.</Note>
    </Block>
  );
}
